import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
import { HelperService } from '../../Services/helper.service';
import { DownloadTestModalComponent } from '../download-test-modal/download-test-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  @ViewChild('updateUsermodal', { static: false }) public updateUsermodal: ModalDirective;
  @ViewChild('voucherupdatemodal', { static: false }) public voucherupdatemodal: ModalDirective;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;
  @ViewChild('changePasswordModal', { static: false }) public changePasswordModal: ModalDirective;
  @ViewChild('alertChangePasswordModal', { static: false }) public alertChangePasswordModal: ModalDirective;

  currentTopUpBalance: number = 0;
  userName: string = "";
  gender: string = "";
  education: string = "";
  occupation: string = "";
  address: string = "";
  country: string = "";
  state: string = "";
  city: string = "";
  editBtnFor:boolean = false;
  // dob = new Date(1990, 12, 1);
  dob: any = new Date();
  age: number = null;
  prefLanguage: string = "";
  mobile: number = null;
  email: string = "";
  wallet: number = 0;
  noneditable: any;
  dobStr = "";
  tableconfig = {};
  tableheaders = [];
  tabledata = [];
  userid: any;
  showUpdatedMsg = ""
  registerby = ""
  userflg = true;
  newuser = false;
  showMsg: boolean = false;
  ErrorMsg = "";
  EmailErrorMsg = "";
  pendingMsg: string = "";
  vcnumber: string = "";
  vcamount: number = null;
  vcpaidby: string = "";
  message = "";
  btntxt = "Add User";
  datafalg = false;
  changePassMsg = "";
  confirmPassErrMsg = "";
  currentPassword = "";
  newPassword = "";
  confPassword = "";
  passwordMatch: boolean = false;
  typeForPassword: string = 'password';
  typeForConPassword: string = 'password';
  //showGtPlusTbl:boolean = false;
  updateBalanceUserName: string = '';
  userDetailOperation: string = '';
  incorrectCurrentPassError:string = "";
  operation:string = 'NEW';
  priviousUserEmail:string = "";
  testLanguages = [
    {
      "value": "e",
      "display": "English"
    },
    {
      "value": "m",
      "display": "Marathi"
    },
    {
      "value": "h",
      "display": "Hindi"
    }
  ]

  constructor(private router: Router, private encryptService: EncrptDecreptService, private ngbModal: NgbModal, private datePipe: DatePipe, private helper: HelperService, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService) { }


  showLoader: boolean = false;
  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.headerName = "User Management";
    }, 80);
    this.dob = new Date();
    // this.getUserDetails();
    this.noneditable = true;
    this.getAllUsers()
    this.checkUserisAdmin();
    // console.log(this.dataManipSrvc)

  }
  checkUserisAdmin() {
    let id = this.dataManipSrvc.userId;
    for (let i = 0; i < this.tabledata.length; i++) {
      if (this.tabledata[i]["userid"] == id) {
        if (this.tabledata[i]["usertype"] != "A")
          this.router.navigateByUrl("/dashboard");
      }
    }
  }

  addWalletBalanceByAdmin() {
    let apiUrl = this.configSetting.getBaseUrl() + "user/rechargeWalletByCash";
    let body =
    {
      "userid": this.encryptService.encrypt(this.userid + ""),
      "vaucherno": this.vcnumber,
      "paymentby": this.vcpaidby,
      "amount": +this.vcamount,
      "paymentstatus": "S",
      "adminuserid": this.dataManipSrvc.userId
    }
    if (!this.vcamount || !this.vcnumber || !this.vcpaidby) {
      return
    }


    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      // if(successResp['errorCode']!== 0){
      //   console.log("helo")
      //   this.dangerModal.show();
      // }
      // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("Set top up .....", JSON.stringify(successResp)); 
        this.getAllUsers();

        /* let tbldataforprocessing=this.tabledata;
       let tblheadersforprocessing=this.tableheaders;
       let tableconfigforprocessing=this.tableconfig;
 
       for(let index=0;index<this.tabledata.length;index++){
         const element=this.tabledata[index];
         if(this.userid==element.userid){
       // console.log(this.tabledata[index]['walletbalance'])
           this.tabledata[index]['walletbalance']=successResp["Data"]["walletbalance"];
       // console.log(this.tabledata[index]['walletbalance'])
 
         }
       }
       this.tableheaders=tblheadersforprocessing
       this.tableconfig=tableconfigforprocessing;
       this.tabledata=this.tabledata;*/
        /*
        this.tabledata=tbldataforprocessing;
        let apiUrl = this.configSetting.getBaseUrl() + "user/getAllRegisterUserList";
     
  
      this.commonServices.getMethod(apiUrl).subscribe(successResp => {
       // this.showLoader = false;
        if (successResp['errorCode'] == "000000") {    
          this.tableheaders = successResp["Data"][0]["@Oritbl"]["tableheaders"];
          this.tableconfig = successResp["Data"][0]["@Oritbl"]["tableconfig"];
         // this.tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
         
        }
      })*/


        /*let tbldataforprocessing=this.tabledata;
        let tblheadersforprocessing=this.tableheaders;
        let tableconfigforprocessing=this.tableconfig;
        
        let apiUrl = this.configSetting.getBaseUrl() + "user/getAllRegisterUserList";
  
        this.commonServices.getMethod(apiUrl).subscribe(successResp => {
       if (successResp['errorCode'] == "000000") {    
         // this.tableheaders = successResp["Data"][0]["@Oritbl"]["tableheaders"];
          //this.tableconfig = successResp["Data"][0]["@Oritbl"]["tableconfig"];
  
         this.tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
          let obj:any;
          for(let index=0;index<this.tabledata.length;index++){
            const element=this.tabledata[index];
            if(this.userid==element.userid){
              obj=element;
              break;
  
            }
          }
          for(let index=0;index<tbldataforprocessing.length;index++){
            let element=tbldataforprocessing[index];
            if(this.userid==element.userid){
              tbldataforprocessing[index]=obj;
              break;
              
            }
          }
      // console.log(this.tabledata)
          this.tabledata=tbldataforprocessing;
          this.tableheaders=tblheadersforprocessing
          this.tableconfig=tableconfigforprocessing
      // console.log(this.tabledata)
         
  
        }
      })*/

        this.closevoucherupdatemodal();

        if (this.currentTopUpBalance != successResp['Data']['walletbalance']) {
          this.message = "Wallet balance Updated!!"
          this.successModal.show();

        }

      }

      else {
        this.message = "Fail to Update Wallet Balance !!"
        this.successModal.show();
      }
    })
  }
  getAllUsers(dataflag = false) {

    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getAllRegisterUserList";


    this.commonServices.getMethod(apiUrl).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.showLoader = false;
        if (dataflag == true) {
          this.tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
        }
        else {
          this.tableheaders = [];
          this.tableconfig = {};
          this.tabledata = [];
          setTimeout(() => {


            this.tableheaders = successResp["Data"][0]["@Oritbl"]["tableheaders"];
            this.tableconfig = successResp["Data"][0]["@Oritbl"]["tableconfig"];
            this.tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
            this.checkUserisAdmin();
            this.tableconfig['actioncolmconfig']['print'] = false;
            this.tableconfig['actioncolmconfig']['view'] = false;
            this.tableconfig['actioncolmconfig']['edit'] = false;
            this.tableconfig['dragdrop']['columns'] = false;
            this.tableconfig["customactionbuttons"] = [
              // {
              //   "tooltip": "View Details",
              //   "text": "",
              //   "icon": "fa fa-eye",
              //   "action": "viewdetails",
              //   "style": {},
              //   "class": "btn-primary"
              // },
              {
                "tooltip": "Edit Details",
                "text": "",
                "icon": "fa fa-pencil",
                "action": "editetails",
                "style": {},
                "class": "btn-warning"
              },
              {
                "tooltip": "Change Password",
                "text": "",
                "icon": "fa fa-lock",
                "action": "changepass",
                "style": {},
                "class": "btn-secondary"
              },
              {
                "tooltip": "Wallet TopUp",
                "text": "",
                "icon": "fa fa-inr",
                "action": "topup",
                "style": {},
                "class": "btn-info"
              },
              {
                "tooltip": "Download PDF's",
                "text": "",
                "icon": "fa fa-print",
                "action": "downloadpdf",
                "style": {},
                "class": "btn-success"
              },
              /*{
                 "tooltip": "Change Password",
                 "text": "",
                 "icon": "fa fa-inr",
                 "action": "changepassword",
                 "style": {},
                 "class": "btn-info"
               }*/
            ]
            this.tableconfig['stickycolumns']['initial'] = 1;
            for (let i = 0; i < this.tabledata.length; i++) {
              this.tabledata[i]['topup'] = true;
              this.tabledata[i]['downloadpdf'] = true;
              // this.tabledata[i]['viewdetails'] = true;
              this.tabledata[i]['editetails'] = true;
              this.tabledata[i]['changepass'] = true;

              if (this.tabledata[i]['mobileno'] == "null") {
                this.tabledata[i]['mobileno'] = null;
              }
              //this.tabledata[i]['changepassword']=true;
            }
      //      console.log(this.tableconfig);

            // for(let i=0;i<this.tableheaders.length;i++){
            //   // if()
            //  }
          }, 50);
        }


        // console.log(this.tableconfig)
        //this.downloadtestmodal.show();
        // this.showGtPlusTbl = true;

      } else {
        this.showLoader = false;
      }
    }, (err) => {
//      console.log(err);
      this.showLoader = false;
    })
  }
  viewAccount(event, operation) {
    this.newuser = true;
    this.userid = event.row.userid;
    this.userflg = true;
    // console.log(operation)
    if (operation == 'view') {
      this.noneditable = true;
      this.getUserDetails();
      this.updateUsermodal.show();
    }
  }
  editAccount() {
    this.priviousUserEmail = this.email;
    this.operation = "EDIT";
    this.userid;
    this.btntxt = "Update"
    this.userflg = false;
    this.noneditable = false;
    this.showUpdatedMsg = "";
  }
  adduser() {
    this.operation = 'NEW';
    this.prefLanguage = 'e';
    this.userflg = false;
    this.userid = 0;
    this.noneditable = false;
    this.registerby = "A";
    this.dob = new Date();
    this.ErrorMsg = '';
    this.EmailErrorMsg = '';
    // this.dob = this.datePipe.transform(this.dob,"yyyy-MM-dd")

    this.calculateAge();
    this.dob = this.dobStr;
    // console.log(this.dob);
    this.updateUsermodal.show();

  }
  clearErrMsg(){

  }
  closeupdateUsermodal() {
    this.newuser = false;
    this.userName = ""
    this.gender = ""
    this.education = "";
    this.occupation = "";
    this.address = "";
    this.country = "";
    this.state = "";
    this.city = "";
    this.dob = new Date();
    this.dob = this.dobStr;
    this.age = null;
    this.prefLanguage = "";
    this.mobile = null;
    this.email = "";
    this.registerby = "A";
    this.updateUsermodal.hide();
    this.showUpdatedMsg = "";
    this.wallet = 0;
    this.showMsg = false;
    this.btntxt = "Add User";

  }

  checkEmailIdEvt() {
    this.showMsg = false;
    this.ErrorMsg = '';
    if (this.email == "") return;
    this.showLoader = true;
    let params = { "emailid": this.email };


    let apiUrl = this.configSetting.getBaseUrl() + "user/CheckEmailId";
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      this.showLoader = false;
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        
        let lvUserId = +this.encryptService.decrypt(successResp['Data'][0]['userid']);
        console.log(this.userid, lvUserId);
        
        if(this.operation == 'NEW'){
          this.ErrorMsg = "This email is already registered.";
          this.EmailErrorMsg = ""
        }else if(this.operation == 'EDIT' && (this.userid == lvUserId)){
          this.ErrorMsg = "";
          this.EmailErrorMsg = "";
        }else{
          this.EmailErrorMsg = `${this.email} this email is already registered.`;
          this.email = this.priviousUserEmail;
        }
        this.showMsg = true;
        //this.regEmailImgSrc = "../../../assets/img/form-loader/remove.png";

      }
      else if (successResp["Data"]["validemail"]) {

        this.showMsg = true;
        this.EmailErrorMsg = "";
        this.ErrorMsg = successResp["errorDescription"];
        //this.regEmailImgSrc = "../../../assets/img/form-loader/remove.png";

      }

      if (successResp['errorDescription'] == 'This EmailId are not registered') {
        this.noneditable = false;
      }

    })

  }
  calculateAge() {
    // this.age = 0;
    let timeDiff = Math.abs(Date.now() - this.dob.getTime());
    this.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    this.dobStr = this.datePipe.transform(this.dob, "yyyy-MM-dd")
  }


  saveUserProfile() {
    this.showLoader = true;
    if (!this.education) {
      this.education = "";
    } else if (!this.occupation) {
      this.occupation = "";
    } else if (!this.dobStr || this.dobStr == null || this.dobStr == undefined) {
      this.dobStr = "";
    } else if (!this.wallet) {
      this.wallet = 0;
    }
    let apiUrl = this.configSetting.getBaseUrl() + "user/SaveUserMaster";
    let body = {
      "dob": this.dobStr ? this.dobStr : '',
      "age": this.age ? this.age : '',
      "city": this.city ? this.city : '',
      "state": this.state ? this.state : '',
      "gender": this.gender ? this.gender : 'M',
      "userid": this.encryptService.encrypt(this.userid + ""),
      "address": this.address ? this.address : '',
      "country": this.country ? this.country : '',
      "emailid": this.email,
      "mobileno": this.mobile ? this.mobile : '',
      "username": this.userName,
      "education": this.education ? this.education : '',
      "occupation": this.occupation ? this.occupation : '',
      "preflanguage": this.encryptService.encrypt(this.prefLanguage),
      "walletbalance": this.encryptService.encrypt(this.wallet + ""),
      "userprofileimage": "",
      "registerby": this.registerby
    }
    console.log("Proflie JSON: ", body, this.userid);
    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("Set Password .....", JSON.stringify(successResp)); 
        this.noneditable = true;
        this.editBtnFor = true;
        if (this.newuser) {
          // console.log("newuser",this.newuser);

          this.showUpdatedMsg = successResp['errorDescription'];

        } else
          this.showUpdatedMsg = successResp['errorDescription'];
        this.getAllUsers();
        this.userflg = true;
        this.EmailErrorMsg = "";
        this.ErrorMsg = "";
      }

      else {
        // console.log("working")
        // alert("Please select Date");
        // this.dangerModal.show();
      }
    })
  }
  getUserDetails() {
    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getUserDetailByUserId";
    let body = {
      "userid": this.encryptService.encrypt(this.userid + "")
    }

    this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        let userData = {};
        userData = successResp["Data"][0];
        if (userData["dob"] == "0000-00-00") {
          userData["dob"] = "";
        } else if (userData["occupation"] == "null") {
          this.occupation = "";
        } else if (userData["address"] == "null") {
          userData["address"] = "";
        } else if (userData["country"] == "null") {
          userData["country"] = "";
        } else if (userData["state"] == "null") {
          userData["state"] = "";
        } else if (userData["city"] == "null") {
          userData["city"] = "";
        }

        this.userName = userData["username"];
        this.gender = userData["gender"];
        this.education = userData["education"];
        this.occupation = userData["occupation"];
        this.address = userData["address"];
        this.country = userData["country"];
        this.state = userData["state"];
        this.city = userData["city"];
        this.dob = userData["dob"] ? new Date(userData["dob"]) : '';
        this.dobStr = userData["dob"];
        this.age = userData["age"];
        this.prefLanguage = userData["preflanguage"];
        this.mobile = userData["mobileno"];
        this.email = userData["emailid"];
        this.registerby = userData["registerby"];
        this.wallet = userData["walletbalance"];
        // console.log(this.dob,"date");

        //  this.wallet = userData["wallet"];

      }
    })
  }

  viewvoucherupdatemodal(event) {
    console.log(event);

    this.userid = event.row.userid;
    this.updateBalanceUserName = event.row.username;
    if (event?.buttonObj?.action == "topup") {
      this.currentTopUpBalance = event.row.walletbalance;
      this.voucherupdatemodal.show();
      this.vcamount = null;
      this.vcnumber = "";
      this.vcpaidby = "";
    } else if (event?.buttonObj?.action == "downloadpdf") {
      if (event.row['regstatus'] == 'P') {
        this.pendingMsg = "User verification is pending, cannot download pdf's.";
        this.alertChangePasswordModal.show();
        return;
      }
      this.openDownloadTestModal(this.userid, this.updateBalanceUserName);
    } else 
    // if (event?.buttonObj?.action == "viewdetails") {
    //   this.userDetailOperation = "viewdetails";
    //   this.newuser = true;
    //   this.userflg = true;
    //   this.noneditable = true;
    //   this.getUserDetails();
    //   this.updateUsermodal.show();
    // } else 
    if (event?.buttonObj?.action == "editetails") {
      this.newuser = true;
      this.userflg = true;
      this.noneditable = true;
      this.getUserDetails();
      this.updateUsermodal.show();
    } else if (event?.buttonObj?.action == "changepass") {
      if (event.row['regstatus'] != 'V') {
        this.pendingMsg = "User verification is pending, cannot change password.";
        this.alertChangePasswordModal.show();
        return;
      }
      this.currentPassword = event.row.password;
      this.changePasswordModal.show();
    }



  }

  openDownloadTestModal(userId, userName) {
    const ngbModalRef = this.ngbModal.open(DownloadTestModalComponent, { windowClass: "download-test-modal", backdrop: 'static' });
    ngbModalRef.componentInstance.userid = userId;
    ngbModalRef.componentInstance.openFromAdminSide = true;
    ngbModalRef.componentInstance.username = userName;

    ngbModalRef.result.then((result) => {
//      console.log("result");

      if (result && result?.status == "finish") {

      }
    });
  }

  closevoucherupdatemodal() {
    this.vcpaidby = "";
    this.vcnumber = "";
    this.vcamount = 0
    this.voucherupdatemodal.hide();
  }
  viewResetPasswordModel(event) {
    console.log(event, "event")
    if (event.row['regstatus'] != 'V') {
      this.pendingMsg = "User verification is pending, cannot change password.";
      this.alertChangePasswordModal.show();
      return;
    }
    this.userid = event.row.userid;
    this.currentPassword = event.row.password;
    this.changePasswordModal.show();
  }
  ClearSearchbox(itemdata: any) {
    itemdata = this.helper.removeRefrence(itemdata);
    // console.log(itemdata,"item");

  }
  checkPassword() {
    this.incorrectCurrentPassError = "";
    // if (this.newPassword.length < 6) {
    //   this.incorrectCurrentPassError = "Password must be at least 6 charachters."
    //   this.passwordMatch = false;
    //   return;
    // }
    if (this.confPassword != "") {
      if (this.newPassword != this.confPassword) {
        // this.passCheckImgSrc = "../../../assets/img/form-loader/remove.png";
        this.incorrectCurrentPassError = "New password and confirmation password do not match."
        this.passwordMatch = false;
      }
      else {
        this.incorrectCurrentPassError = "";
        // this.passCheckImgSrc = "../../../assets/img/form-loader/check.png";
        this.passwordMatch = true;
      }
    }
    else {
      //  this.passCheckImgSrc = "";
    }
  }
  changePasswordEvt() {
    this.showLoader = true;
    this.changePassMsg = "";
    this.confirmPassErrMsg = "";
    let apiUrl = this.configSetting.getBaseUrl() + "user/changePassword";
    let body = {
      "cpl": this.encryptService.encrypt(this.currentPassword),
      "npl": this.encryptService.encrypt(this.newPassword),
      "unl": this.encryptService.encrypt(this.userid + "")
    }

    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        //console.log("Set Password .....", JSON.stringify(successResp));       
        // this.changePassMsg = "Your Password is changed successfully.";
        this.successModal.show();
        this.message = successResp['errorDescription']; 
        // alert("Your Password is changed successfully.");
        this.currentPassword = "";
        this.newPassword = "";
        this.confPassword = "";
        this.changePasswordModal.hide();
        this.getAllUsers();
        // console.log(this.currentPassword,"pass");

      }
      else {
        this.confirmPassErrMsg = successResp["errorDescription"];
      }
    })
  }

  changeViewOfPasswrd(FOR, typeForPassword) {
    if (typeForPassword == 'password') {
      if (FOR == 'pass') {
        this.typeForPassword = 'text';
      }
      else {
        this.typeForConPassword = 'text';
      }
    }
    else {
      if (FOR == 'pass') {
        this.typeForPassword = 'password';
      }
      else {
        this.typeForConPassword = 'password';
      }
    }
    if(this.newPassword){

    }
  }

  checkRecComment(){
    let inputBox = document.getElementById("mobileno");
    
    let invalidChars = ["e", "+", "-"]

    inputBox.addEventListener("keydown", function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }

}
